"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboard = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const antd_1 = require("antd");
const AdminDashboardStats_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/dashboard/AdminDashboardStats");
const AdminMGTProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/AdminMGTProvider");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const DashboardRefreshComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/dashboard/DashboardRefreshComponent");
const AdminDashboardDAU_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/dashboard/AdminDashboardDAU");
const AdminDashboardParticipants_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/dashboard/AdminDashboardParticipants");
const AdminDashboardProjects_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/dashboard/AdminDashboardProjects");
const AdminDashboard = () => {
    const isMounted = (0, isMounted_1.default)();
    const adminMGTContext = (0, AdminMGTProvider_1.useAdminMGTContext)();
    (0, react_1.useEffect)(() => {
        if (isMounted()) {
            (async () => {
                await adminMGTContext.getInformation(undefined);
                await adminMGTContext.getCanisterMetrics();
            })();
        }
    }, [isMounted]);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.PageHeader, { title: "Usergeek Admin Panel", extra: React.createElement(DashboardRefreshComponent_1.DashboardRefreshComponent, null) }),
        React.createElement(PageContent_1.default, null,
            React.createElement(AdminDashboardStats_1.AdminDashboardStats, null),
            React.createElement(AdminDashboardDAU_1.AdminDashboardDAU, null),
            React.createElement(AdminDashboardParticipants_1.AdminDashboardParticipants, null),
            !!process.env.IS_TEST_SERVER && React.createElement(AdminDashboardProjects_1.AdminDashboardProjects, null)));
};
exports.AdminDashboard = AdminDashboard;
